import { relations } from 'drizzle-orm';
import { foreignKey, index, integer, pgTable, serial, text, timestamp, unique, uniqueIndex } from 'drizzle-orm/pg-core';
import { application } from './application';
import { organization } from './organization';

export const trackingDomain = pgTable(
  'tracking_domain',
  {
    id: serial().primaryKey(),
    organization_id: integer()
      .notNull()
      .references(() => organization.id, { onDelete: 'cascade' }),
    domain: text().notNull(),
    created_at: timestamp({ withTimezone: true, mode: 'string' }).notNull().defaultNow(),
  },
  (t) => [
    uniqueIndex('tracking_domain_domain_uq').on(t.domain),
    unique('tracking_domain_id_organization_id_uq').on(t.id, t.organization_id),
    index('tracking_domain_organization_id_idx').on(t.organization_id),
  ],
);

export const trackingDomainRelations = relations(trackingDomain, ({ many, one }) => ({
  organization: one(organization, {
    fields: [trackingDomain.organization_id],
    references: [organization.id],
  }),
  applications: many(trackingApplicationDomain),
}));

export type TrackingDomain = typeof trackingDomain.$inferSelect;
export type InsertTrackingDomain = typeof trackingDomain.$inferInsert;

export const trackingApplicationDomain = pgTable(
  'tracking_application_domain',
  {
    id: serial().primaryKey(),
    tracking_domain_id: integer().notNull(),
    application_id: integer().notNull(),
    organization_id: integer()
      .notNull()
      .references(() => organization.id, { onDelete: 'cascade' }),
    created_at: timestamp({ withTimezone: true, mode: 'string' }).notNull().defaultNow(),
  },
  (t) => [
    uniqueIndex('tracking_application_domain_domain_application_uq').on(t.tracking_domain_id, t.application_id),
    index('tracking_application_domain_application_id_idx').on(t.application_id),
    index('tracking_application_domain_domain_id_idx').on(t.tracking_domain_id),
    foreignKey({
      columns: [t.application_id, t.organization_id],
      foreignColumns: [application.id, application.organization_id],
      name: 'tracking_application_domain_application_organization_fk',
    }).onDelete('cascade'),
    foreignKey({
      columns: [t.tracking_domain_id, t.organization_id],
      foreignColumns: [trackingDomain.id, trackingDomain.organization_id],
      name: 'tracking_application_domain_domain_organization_fk',
    }).onDelete('cascade'),
  ],
);

export const trackingApplicationDomainRelations = relations(trackingApplicationDomain, ({ one }) => ({
  trackingDomain: one(trackingDomain, {
    fields: [trackingApplicationDomain.tracking_domain_id],
    references: [trackingDomain.id],
  }),
  application: one(application, {
    fields: [trackingApplicationDomain.application_id],
    references: [application.id],
  }),
}));

export type TrackingApplicationDomain = typeof trackingApplicationDomain.$inferSelect;
export type InsertTrackingApplicationDomain = typeof trackingApplicationDomain.$inferInsert;
